import React, { useState } from 'react';

const VALUES_DATA = [
  {
    num: '01',
    title: 'Curiosity',
    desc: 'We encourage our team members to question the norm and explore innovative solutions to problems.'
  },
  {
    num: '02',
    title: 'Honesty',
    desc: 'We value integrity and ethical behavior in all our interactions, both internally and externally.'
  },
  {
    num: '03',
    title: 'Positivity',
    desc: 'We value the power of positivity and believe that it leads to higher productivity, creativity, and job satisfaction.'
  },
  {
    num: '04',
    title: 'Impact',
    desc: 'We strive to make a meaningful impact in everything we do at Technomites.'
  },
  {
    num: '05',
    title: 'Disruption',
    desc: 'We believe that disruptive innovation is the key to solving complex problems and creating new opportunities.'
  }
];

function MissionVisionValues() {
  const [activeTab, setActiveTab] = useState('mission');

  return (
    <section className="mvv-section">
      <div className="container mvv-container">

        {/* Navigation Tabs Header */}
        <div className="mvv-tabs-wrapper">
          <div className="mvv-tabs-header">
            <button
              className={`mvv-tab-btn ${activeTab === 'mission' ? 'active' : ''}`}
              onClick={() => setActiveTab('mission')}
            >
              Mission
              <span className="mvv-tab-indicator"></span>
            </button>
            <button
              className={`mvv-tab-btn ${activeTab === 'vision' ? 'active' : ''}`}
              onClick={() => setActiveTab('vision')}
            >
              Vision
              <span className="mvv-tab-indicator"></span>
            </button>
            <button
              className={`mvv-tab-btn ${activeTab === 'values' ? 'active' : ''}`}
              onClick={() => setActiveTab('values')}
            >
              Values
              <span className="mvv-tab-indicator"></span>
            </button>
          </div>
          <div className="mvv-tabs-divider"></div>
        </div>

        {/* Tab Content Display */}
        <div className="mvv-content-wrapper">

          {/* Mission Tab Content */}
          {activeTab === 'mission' && (
            <div className="mvv-tab-pane fade-in" key="mission">
              <div className="mvv-left">
                <div className="mvv-badge">
                  <span className="mvv-badge-dot"></span>
                  OUR MISSION
                </div>
                <h3 className="mvv-title">
                  To be <span className="highlight-gradient">forever curious</span> and impactful in revolutionizing technology for our partner
                </h3>
                <p className="mvv-desc lead">
                  We aspire to create and deliver the best digital solutions for businesses wanting to acquire a competitive edge in the industry and serve their customers through robust digital channels.
                </p>
                <p className="mvv-desc">
                  Technomites aims to help startups and organizations recognize their potential and leverage optimum, highly customized solutions for business growth and ROI.
                </p>

              </div>
              <div className="mvv-right">
                <div className="mvv-img-frame">
                  <div className="mvv-ambient-glow red-glow"></div>
                  <img
                    src="/assets/images/mission.png"
                    alt="Our Mission"
                    className="mvv-img"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Vision Tab Content */}
          {activeTab === 'vision' && (
            <div className="mvv-tab-pane fade-in" key="vision">
              <div className="mvv-left">
                <div className="mvv-badge">
                  <span className="mvv-badge-dot"></span>
                  OUR VISION
                </div>
                <h3 className="mvv-title">
                  Transforming the world through <span className="highlight-gradient">technologies that disrupt</span>
                </h3>
                <p className="mvv-desc lead">
                  We aim to extend the scope of current technologies into societal issues and deliver back to the community for the greater good.
                </p>
                <p className="mvv-desc">
                  Our vision is to help 20 million lives with better education and employment opportunities, acquire ten active ventures, scale five businesses to exit, get listed to Nasdaq, become the most preferred workplace in Pakistan, and enter the Fortune 500 club in the next five years.
                </p>
              </div>
              <div className="mvv-right">
                <div className="mvv-img-frame">
                  <div className="mvv-ambient-glow blue-glow"></div>
                  <img
                    src="/assets/images/vision.webp"
                    alt="Our Vision"
                    className="mvv-img"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Values Tab Content */}
          {activeTab === 'values' && (
            <div className="mvv-tab-pane fade-in" key="values">
              <div className="mvv-left">
                <div className="mvv-badge">
                  <span className="mvv-badge-dot"></span>
                  CORE VALUES
                </div>
                <h3 className="mvv-title-small">
                  The principles that drive everything we do
                </h3>
                <div className="values-grid">
                  {VALUES_DATA.map((val) => (
                    <div key={val.num} className="value-card">
                      <div className="value-card-header">
                        <span className="value-num">{val.num}</span>
                        <h4 className="value-card-title">{val.title}</h4>
                      </div>
                      <p className="value-card-desc">{val.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mvv-right">
                <div className="mvv-img-frame">
                  <div className="mvv-ambient-glow red-glow"></div>
                  <img
                    src="/assets/images/values.webp"
                    alt="Our Values"
                    className="mvv-img"
                  />
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
}

export default MissionVisionValues;
